import React from 'react'
import { connect } from 'react-redux'
import $ from 'jquery'

import './CatAttrib.css'

class CatAttribPanel extends React.Component {
    constructor(props) {
        super(props);
    }

    processCollapse(e) {
        if (e.target.className.includes("fa-toggle-down")) {
            $("i#" + e.target.id).addClass("fa-toggle-up")
            $("i#" + e.target.id).removeClass("fa-toggle-down")

            $("ul#" + e.target.id).css("display", "block")
        }
        else {
            $("i#" + e.target.id).addClass("fa-toggle-down")
            $("i#" + e.target.id).removeClass("fa-toggle-up")

            $("ul#" + e.target.id).css("display", "none")
        }        
    }

    render() {
        return (
            <div className="catattribPanel">
                <div className="attributes">
                    <div className="attrib-lbl">
                        <p className="web">Web Categories:<i id="web" className="fa fa-toggle-up supp pull-right" onClick={this.processCollapse}></i></p>
                    </div>
                    <ul id="web">
                        {
                            this.props.product.websiteCategory1 && this.props.product.websiteCategory1.length ?
                                <option>{this.props.product.websiteCategory1}</option>
                            :
                                null
                        }
                        {
                            this.props.product.websiteCategory2 && this.props.product.websiteCategory2.length ?
                                <option>{this.props.product.websiteCategory2}</option>
                            :
                                null
                        }
                    </ul>
                </div>

                <div className="attributes">
                    <div className="attrib-lbl">
                        <p className="web">Display Attributes:<i id="disp" className="fa fa-toggle-up supp pull-right" onClick={this.processCollapse}></i></p>
                    </div>
                    <ul id="disp">
                        {
                            this.props.product.displayAttributes ?
                                this.props.product.displayAttributes.map((attr) => {
                                    return <option>{attr.attributeName} - {attr.attributeValueName}</option>
                                })
                            :
                                null
                        }
                    </ul>
                </div>

                <div className="attributes">
                    <div className="attrib-lbl">
                        <p className="web">Filterable Attributes:<i id="filt" className="fa fa-toggle-up supp pull-right" onClick={this.processCollapse}></i></p>
                    </div>
                    <ul id="filt">
                        {
                            this.props.product.filterableAttributes ?
                                this.props.product.filterableAttributes.map((attr) => {
                                    return <option>{attr.attributeName} - {attr.attributeValueName}</option>
                                })
                            :
                                null
                        }
                    </ul>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    product: state.product.product
});

export default connect(mapStateToProps)(CatAttribPanel)